import { inheritsLoose as _inheritsLoose } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import { VisuallyHidden } from '@zillow/constellation';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

var _class;
var Legend = withTheme((_class = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Legend, _Component);
  function Legend() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = Legend.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      data = _this$props.data,
      hoverIndex = _this$props.hoverIndex,
      yAccessor = _this$props.yAccessor,
      colors = _this$props.colors,
      indexFormatter = _this$props.indexFormatter,
      theme = _this$props.theme,
      fontFamily = _this$props.fontFamily;
    var rowStyle = {
      padding: '0 10px 5px',
      textAlign: 'left'
    };
    var firstStyle = {
      paddingTop: '5px'
    };
    var dataStyle = {
      fontWeight: 'bold',
      textAlign: 'right'
    };
    var rows = data.map(function (d, i) {
      var dataPoint = d.values[hoverIndex];
      var yVal = hoverIndex ? yAccessor(dataPoint) : null;
      var appliedFirstStyle = i === 0 ? firstStyle : {};
      var pStyle = {
        display: 'list-item',
        'list-style': 'disc inside',
        'font-size': '15px',
        color: colors(i),
        marginRight: '2px',
        height: '2px',
        width: '3px'
      };
      var thStyle = Object.assign({}, rowStyle, appliedFirstStyle);
      var tdStyle = Object.assign({}, thStyle, dataStyle);
      if (d.formatter) {
        yVal = d.formatter(yVal);
      }
      if (!yVal) {
        return null;
      }
      return /*#__PURE__*/React.createElement("tr", {
        key: d.name
      }, /*#__PURE__*/React.createElement("th", {
        style: thStyle
      }, /*#__PURE__*/React.createElement("span", {
        style: pStyle
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          'padding-left': '10px'
        }
      }, ' ', d.name, ' ')), /*#__PURE__*/React.createElement("td", {
        style: tdStyle
      }, yVal, /*#__PURE__*/React.createElement(VisuallyHidden, null, dataPoint.info)));
    });
    var xRowDataStyle = Object.assign({}, rowStyle, dataStyle, {
      fontWeight: 'normal',
      fontSize: '10px'
    });
    var formattedX = indexFormatter(hoverIndex);
    var xRowContents = /*#__PURE__*/React.createElement("tr", {
      key: "month"
    }, /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("td", {
      style: xRowDataStyle
    }, formattedX));
    var xRow = formattedX ? xRowContents : null;
    var boxStyle = {
      position: 'absolute',
      top: '15px',
      left: '25px',
      backgroundColor: theme.constellation.colors.borderLight,
      border: "1px solid " + theme.constellation.colors.borderDark,
      textAlign: 'left',
      fontSize: '12px',
      fontFamily: fontFamily
    };
    if (!xRow) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "linechart-legend",
      style: boxStyle,
      "aria-live": "polite",
      "aria-atomic": "true"
    }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, rows, xRow)));
  };
  return Legend;
}(Component), _class.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    values: PropTypes.array
  })),
  hoverIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  indexFormatter: PropTypes.func,
  yAccessor: PropTypes.func,
  colors: PropTypes.func,
  theme: PropTypes.object,
  fontFamily: PropTypes.string
}, _class));

export { Legend as default };
